<template>
    <div class="tabmenu-container">
        <div class="tabmenu-header">
            <ul class="tabmenu-menu">
                <li class="tabmenu-menu-item"
                    v-for="tab in tabs"
                    :key="tab"
                    v-bind:class="{'tab-head--active': activeTab === tab}"
                    v-on:click="switchTab(tab)">
                    <slot :name="tabHeadSlotName(tab)">
                        {{ tab }}
                    </slot>
                </li>
            </ul>
        </div>

        <div class="tabmenu-main">
            <div class="tabmenu-panel">
                <slot :name="tabPanelSlotName">
                </slot>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "TabMenu",
        props: {
            tabs: Array,
            initialTab: String
        },
        data() {
            return {
                activeTab: this.initialTab
            };
        },
        computed: {
            tabPanelSlotName() {
                return `tab-panel-${this.activeTab}`;
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            tabHeadSlotName(tabName) {
                return `tab-head-${tabName}`;
            },
            switchTab(tabName) {
                this.activeTab = tabName;
            }
        },
        components: {
        }
    };
</script>